var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 0C104.003 0 134 29.997 134 67C134 104.003 104.003 134 67 134C29.997 134 0 104.003 0 67C0 29.997 29.997 0 67 0V0Z",
    fill: "#151447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2247 56.0491L45.6797 66.786L55.6494 77.8103L69.5503 100.147H89.6819L66.3864 66.4985L89.49 34H69.6456L56.2247 56.0491V56.0491Z",
    fill: "url(#paint0_linear_0_10129)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7616 34H23.6294L45.6792 66.786L22 100.147H42.803L55.6489 77.8103L66.3855 66.4985L56.2239 56.0491L43.7616 34V34Z",
    fill: "url(#paint1_linear_0_10129)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0186 34.4207H112.644",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5078 39.8589H112.644",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7246 50.7356H112.644",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7637 67.0505H112.643",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0566 45.2974H112.644",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.167 61.6123H112.643",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7969 56.1738H112.643",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_10129",
    x1: 88.6299,
    y1: 36.7668,
    x2: 48.3086,
    y2: 36.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186242,
    stopColor: "#9225FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403841,
    stopColor: "#8318FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594083,
    stopColor: "#7426FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813739,
    stopColor: "#3840CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_10129",
    x1: 65.3242,
    y1: 36.7666,
    x2: 24.6514,
    y2: 36.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236372,
    stopColor: "#9225FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424716,
    stopColor: "#8318FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621283,
    stopColor: "#7426FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811682,
    stopColor: "#3840CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578EE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbr);
export default __webpack_public_path__ + "static/media/XBR.6188d2970a0756c748112c0747fcb42a.svg";
export { ForwardRef as ReactComponent };